import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { environment } from '@environments/environment';
import { AppModule } from './app/app.module';

// เปิด vConsole ผ่าน CDN เมื่อเปิดจาก env หรือแนบ ?debug/?vconsole ใน URL
(function enableVConsoleIfNeeded() {
  const enabledByEnv = (environment as any).enableVConsole === true;
  const enabledByQuery = /[?&](debug|vconsole)(=1|=true)?/i.test(
    location.search
  );

  if (!(enabledByEnv || enabledByQuery)) return;

  const s = document.createElement('script');
  s.src = 'https://unpkg.com/vconsole@latest/dist/vconsole.min.js';
  s.async = true;
  s.onload = () => {
    (window as any).vConsole = new (window as any).VConsole({});
  };
  document.head.appendChild(s);
})();

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.log(err));

